import { Filters } from '@/types';
import { BaseMutations } from '@/store/base-mutations';
import {
  ApiTokenKey,
  CompanyAccount,
  CompanyContract,
  DeliveryAddress,
  Organizations,
  TransportCompany,
  WebhookLog,
  Contract,
  WebhookObject,
  WebhookObjectBlock,
} from '../types';
import OrganizationState from './state';

export default class OrganizationMutations extends BaseMutations<OrganizationState> {
  SET_USER_ORGANIZATION(organization: Organizations.UserOrganization) {
    this.state.user_orginazation = organization;
  }

  SET_FILTERS(filters: Filters) {
    this.state.filters = filters;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof Filters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_ORGANIZATIONS(orgs: Organizations.Organization[]) {
    this.state.organizations = orgs;
  }

  SET_ORGANIZATIONS_WITH_ASC_STATUS(orgs: Organizations.Organization[]) {
    this.state.organizationsWithAscStatus = orgs.filter((org) => org.is_service_contract);
  }

  SET_CURRENT_ORGANIZATION(item: Organizations.Organization) {
    this.state.current_organization = item;
  }

  SET_DELIVERY_ADDRESSES(addr: DeliveryAddress[]) {
    this.state.delivery_addresses = addr;
  }

  SET_TRANSPORT_COMPANIES(company: TransportCompany[]) {
    this.state.transport_companies = company;
  }

  ADD_DELIVERY_ADDRESSES(addr: DeliveryAddress) {
    this.state.delivery_addresses.push(addr);
  }

  ADD_TRANSPORT_COMPANY(company: TransportCompany) {
    this.state.transport_companies.push(company);
  }

  SET_ACCOUNTS(accounts: CompanyAccount[]) {
    this.state.company_accounts = accounts;
  }

  SET_CONTRACTS(contracts: CompanyContract[]) {
    this.state.company_contracts = contracts;
  }

  SET_CONTRACTS_ACTIVE_COUNT(active_count: number) {
    this.state.company_contracts_active_count = active_count;
  }

  TOGGLE_ACTIVE_CONTRACT_FILTER(toggle: boolean) {
    this.state.filters_active_contracts.is_only_active = toggle;
  }

  UPD_SALE_POINT(point: Organizations.SalePoint) {
    const idx = this.state.sale_points.findIndex((el) => el.id === point.id);

    if (idx >= 0) {
      this.state.sale_points[idx] = point;
    }
  }

  SET_CITIES(cities: string[]) {
    this.state.cities = cities;
  }

  SET_SALES_POINTS(points: Organizations.SalePoint[]) {
    this.state.sale_points = points;
  }

  ADD_SALE_POINT(point: Organizations.SalePoint) {
    this.state.sale_points.push(point);
  }

  SET_API_TOKEN_KEY(data: ApiTokenKey) {
    if (data.api_token) {
      this.state.user_orginazation.api_token = data.api_token;
    }

    if (data.api_token_hidden) {
      this.state.user_orginazation.api_token_hidden = data.api_token_hidden;
    }
  }

  SET_API_KEY_MESSAGE(value: string) {
    this.state.api_key_message = value;
  }

  SET_API_KEY_MESSAGE_TOGLE(value: boolean) {
    this.state.api_key_message_toggle = value;
  }

  SET_WEBHOOK_LOGS(logs: WebhookLog[]) {
    this.state.webhook_logs = logs;
  }

  SET_WEBHOOK_LOGS_LOADING(loading: boolean) {
    this.state.webhook_logs_loading = loading;
  }

  SET_WEBHOOK_ERROR_MESSAGE(message: string) {
    this.state.webhook_error_message = message;
  }

  SET_CONTRACT(contract: Contract) {
    this.state.current_contract = contract;
  }

  SET_WEBHOOK_OBJECTS(webhook_objects: WebhookObject[]) {
    this.state.webhook_objects = webhook_objects;
  }

  SET_WEBHOOK_OBJECT_BLOCK(webhookObjectBlock: WebhookObjectBlock) {
    const webhookObject = this.state.webhook_objects
      .find((value) => value.id === webhookObjectBlock.webhook_object_id);

    if (webhookObject) {
      webhookObject.webhook_object_block = webhookObjectBlock;
    }
  }

  DELETE_WEBHOOK_OBJECT_BLOCK(webhookObjectBlock: WebhookObjectBlock) {
    const webhookObject = this.state.webhook_objects
      .find((value) => value.id === webhookObjectBlock.webhook_object_id);

    if (webhookObject) {
      webhookObject.webhook_object_block = null;
    }
  }
}
